import { ShieldCheck } from 'lucide-react';

export function PrivacyNotice() {
  return (
    <div className="privacy-notice" role="note">
      <ShieldCheck size={22} aria-hidden="true" />
      <p>
        このツールは Google Maps Timeline のエクスポートファイルをブラウザ内で解析します。
        ファイルはサーバーにアップロードされません。
      </p>
    </div>
  );
}
